module.exports = __webpack_public_path__ + "img/单独空间，私域订货.e72e0d70.png";